module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"></svg>"